import { IFinancialData } from "../../../interfaces/account-registration/financial-data.interface";
import { AddressDto } from "./address.dto";

export class FinancialDto {
  phone: string;
  mobileNumber: string;
  email: string;
  invoicePreference: number;
  salutation: string;
  firstName: string;
  lastName: string;
  address: AddressDto;

  constructor(financialData: IFinancialData) {
    this.phone = financialData.phone.value;
    this.mobileNumber = financialData.mobile.value;
    this.email = financialData.email.value;
    this.invoicePreference = financialData.electronicInvoicing.value ? 1 : 0;
    this.salutation = financialData.salutation.value;
    this.firstName = financialData.firstName.value;
    this.lastName = financialData.lastName.value;

    //Address
    this.address = new AddressDto(
      financialData.addressLine1.value,
      financialData.addressLine2.value,
      financialData.addressLine3.value,
      financialData.addressLine4.value,
      financialData.postCode.value,
      financialData.county.value,
      financialData.country.value
    );
  }
}
